import {useState} from "react";
import Collapse from "react-bootstrap/Collapse";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";
import WasteTypesSelect from "site-apps/assets/components/WasteTypesSelect";
import useCustomTranslation from "core/customTranslation";
import translations from "../translations";
import SearchSelect from "components/selects/SearchSelect";
import {useTranslation} from "react-i18next";

const FormFiltersModel = {
    min: "",
    max: "",
    uid: "",
    uuid: "",
    waste_type: "",
    download_type: "",
    group: "",
    zone: "",
    route: "",
    island: "",
};

const ContainerListFilters = ({
    filters,
    params,
    applyFilters,
    downloadFilters,
    setItemsShown,
}) => {
    const labelStyle = {width: "100%", fontWeight: "bold", textAlign: "center"};
    const [formFilters, setFormFilters] = useState({...FormFiltersModel});
    const {t: tC} = useCustomTranslation(translations);
    const {t: _tT} = useTranslation("tags");

    const onChangeSelect = (e) => {
        const {name, value} = e.target;
        setFormFilters({...formFilters, [name]: value});
        if (value) {
            filters.current.chosen[name] = value;
        } else {
            delete filters.current.chosen[name];
        }
    };

    const handleClearFilters = () => {
        filters.current.chosen = {};
        setFormFilters({...FormFiltersModel});
        setItemsShown([]);
    };

    const handleInputChange = (e) => {
        let {name, value} = e.target;
        value = value.trim().toUpperCase();
        setFormFilters({...formFilters, [name]: value});
        filters.current.chosen[name] = value;
        if (value) {
            filters.current.chosen[name] = value;
        } else {
            delete filters.current.chosen[name];
        }
    };

    // console.log("filters.current", filters.current);

    return (
        <Collapse in={true}>
            <div id="filter-collapse">
                <div className="row">
                    <Button
                        variant="link"
                        type="button"
                        onClick={handleClearFilters}
                        style={{color: "black"}}
                        className="col-1">
                        <FontAwesomeIcon icon="broom" />
                    </Button>
                    <div className="col" style={{maxWidth: "160px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_tT("common.download")}
                        </label>
                        <DownloadTypesSelect
                            multiple={false}
                            value={formFilters.download_type}
                            onChange={onChangeSelect}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "160px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {tC("filters.wasteType")}
                        </label>
                        <WasteTypesSelect
                            multiple={false}
                            value={formFilters.waste_type}
                            onChange={onChangeSelect}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{tC("filters.groups")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: tC("filters.all")},
                                ...params.groups.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    group: option ? option.value : "",
                                });
                                if (option) {
                                    filters.current.chosen.group = option.value;
                                } else {
                                    delete filters.current.chosen.group;
                                }
                            }}
                            value={
                                params.groups
                                    .filter((g) => g.id === formFilters.group)
                                    .map((g) => ({
                                        value: g.id,
                                        label: g.name,
                                    }))[0] || null
                            }
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{tC("filters.zones")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: tC("filters.all")},

                                ...params.zones.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    zone: option ? option.value : "",
                                });
                                if (option) {
                                    filters.current.chosen.zone = option.value;
                                } else {
                                    delete filters.current.chosen.zone;
                                }
                            }}
                            value={
                                params.zones
                                    .filter((g) => g.id === formFilters.zone)
                                    .map((g) => ({
                                        value: g.id,
                                        label: g.name,
                                    }))[0] || null
                            }
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{tC("filters.routes")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: tC("filters.all")},
                                ...params.routes.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    route: option ? option.value : "",
                                });
                                if (option) {
                                    filters.current.chosen.route = option.value;
                                } else {
                                    delete filters.current.chosen.route;
                                }
                            }}
                            value={
                                params.routes
                                    .filter((g) => g.id === formFilters.route)
                                    .map((g) => ({
                                        value: g.id,
                                        label: g.name,
                                    }))[0] || null
                            }
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{tC("filters.islands")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: tC("filters.all")},
                                ...params.islands.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    island: option ? option.value : "",
                                });
                                if (option) {
                                    filters.current.chosen.island = option.value;
                                } else {
                                    delete filters.current.chosen.island;
                                }
                            }}
                            value={
                                params.islands
                                    .filter((g) => g.id === formFilters.island)
                                    .map((g) => ({
                                        value: g.id,
                                        label: g.name,
                                    }))[0] || null
                            }
                        />
                    </div>

                    <div className="col pt-3 mt-2">
                        <button
                            type="button"
                            onClick={applyFilters}
                            className="btn btn-outline-primary me-3"
                            title="Aplicar">
                            <FontAwesomeIcon icon="magnifying-glass" />{" "}
                            {tC("filters.search")}
                        </button>
                    </div>
                </div>
                <div className="row pt-3">
                    <div className="col-1 h5 pt-3 text-center">

                    </div>
                    <div className="col mb-3" style={{maxWidth: "250px"}}>
                        <label style={labelStyle}>{tC("filters.containerUID")}</label>
                        <input
                            type="text"
                            className="form-control"
                            name="uid"
                            value={formFilters.uid}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col mb-3" style={{maxWidth: "250px"}}>
                        <label style={labelStyle}>{tC("filters.deviceUUID")}</label>
                        <input
                            type="text"
                            className="form-control"
                            name="uuid"
                            value={formFilters.uuid}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "260px"}}>
                        <label style={labelStyle}>{tC("filters.fillLevel")}</label>
                        <div className="row">
                            <div className="col-6">
                                <input
                                    type="number"
                                    className="form-control"
                                    name="min"
                                    placeholder={tC("filters.minimum")}
                                    value={formFilters.min}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-6">
                                <input
                                    type="number"
                                    className="form-control"
                                    name="max"
                                    placeholder={tC("filters.maximum")}
                                    value={formFilters.max}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col pt-3 mt-2 text-end">
                        <button
                            type="button"
                            className="btn btn-primary"
                            title="CSV"
                            onClick={downloadFilters}>
                            <FontAwesomeIcon icon="download" />{" "}
                            {tC("filters.downloadCSV")}
                        </button>
                    </div>
                </div>
            </div>
        </Collapse>
    );
};

export default ContainerListFilters;
